import * as i18n from "../../i18n.ts";
import * as Html from "../../util/Html.ts";

Html.registerWidget('widget/specific/useeventcolor',{initDom})

function initDom(obj: HTMLElement): void {
  const input = obj.querySelector('input');
  const sub4 = obj.querySelector('.sub4');


  const handleChange = (): void => {
    const key =
      input.value === 'true'
        ? 'calendars.singlecoloron'
        : 'calendars.singlecoloroff';

    sub4.innerHTML = i18n.get(key);
  };

  // Ajout de l’écouteur
  input.addEventListener('change', handleChange);

  // Déclenche le comportement initial (équivalent à trigger('change'))
  handleChange();
}